/**
 * Gates da Visão operacional.
 *
 * A tela está ligada em todos os ambientes (o time de operação acompanha em
 * produção); `REACT_APP_OPS_OVERVIEW_ENABLED=false` desliga menu e rota.
 * Usa `REACT_APP_NODE_ENVIRONMENT` e não `NODE_ENV`: o build de staging também sai
 * com NODE_ENV=production.
 */
const ENV = process.env.REACT_APP_NODE_ENVIRONMENT ?? '';

export const OPS_OVERVIEW_ENABLED =
  process.env.REACT_APP_OPS_OVERVIEW_ENABLED !== 'false';

export const OPS_OVERVIEW_USE_FIXTURE =
  !process.env.REACT_APP_OPS_OVERVIEW_API_URL;

/** Rota pública sem login, só no servidor de dev, para iterar a UI com fixtures. */
export const OPS_OVERVIEW_DEV_PREVIEW = process.env.NODE_ENV !== 'production';

export type OverviewSource = 'fixture' | 'live';

/** Fora de produção dá para alternar Exemplo | Real na barra. */
export const OPS_OVERVIEW_SOURCE_TOGGLE = ENV !== 'production';

/**
 * Produção lê sempre os endpoints reais. Fora dela, `?fonte=real|exemplo` (sem
 * restart do dev server) ou `REACT_APP_OPS_OVERVIEW_SOURCE=live`; senão, fixtures.
 */
export const resolveSource = (fonteParam: string | null): OverviewSource => {
  if (ENV === 'production') return 'live';
  if (fonteParam === 'real') return 'live';
  if (fonteParam === 'exemplo') return 'fixture';
  return process.env.REACT_APP_OPS_OVERVIEW_SOURCE === 'live'
    ? 'live'
    : 'fixture';
};

/**
 * Onde os casos ficam guardados (responsável, "feito", descartes): a API do
 * ops-monitoring-service, projeto Supabase próprio da visão. Sem a URL, tudo fica só
 * na aba. Prod: `https://<ref>.supabase.co/functions/v1/api/v1/ops-cases`; dev:
 * `/ops-proxy/v1/ops-cases` (src/setupProxy.js, com `OPS_PROXY_TARGET`).
 */
export const OPS_CASES_API_URL =
  process.env.REACT_APP_OPS_CASES_API_URL || undefined;
